var _excluded = ["features"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import Collection from "ol/Collection";
import Vector from 'ol/source/Vector';
import { getCachedOrCreate } from '../util';

/**
 * Internal implementation of VectorSource. Can be used with custom components
 * expecting an ol/source/Vector. See ClusterSource for example.
 *
 * See VectorSource for ready to use component combined with VectorLayer.
 *
 * This is a higher order component that accepts a component that expects
 * a source prop with the created ol/source/Vector. Other props are
 * pass-through.
 *
 * This component creates a ol/source/Vector with the provided features,
 * and updates it when features change.
 *
 * @component
 */
export function VectorSourceImpl(NextComponent) {
  return function (_ref) {
    var features = _ref.features,
      vectorProps = _objectWithoutPropertiesLoose(_ref, _excluded);
    var layerName = vectorProps.layerName,
      map = vectorProps.map;
    var cachedSource = getCachedOrCreate(map, '_vectorSources', layerName, function () {
      return {
        source: new Vector({
          features: features
        }),
        _lastFeatures: features
      };
    });

    // Only update source if features array is changed
    if (cachedSource._lastFeatures !== features) {
      cachedSource.source.clear();
      cachedSource.source.addFeatures(features);
      cachedSource._lastFeatures = features;
    }
    return /*#__PURE__*/React.createElement(NextComponent, _extends({
      source: cachedSource.source
    }, vectorProps));
  };
}
VectorSourceImpl.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Features to be rendered.
   */
  features: PropTypes.oneOfType([PropTypes.instanceOf(Collection), PropTypes.array])
} : {};
export default VectorSourceImpl;